export default class ModHeroBanner {
  constructor(el) {
    this.$el = $(el)

    this.dom = {
      $responsiveImage: this.$el.find('.responsive-image'),
    }
  }

  init() {
    this.loadImagesResponsive()
    this.addEventListener()
  }

  addEventListener() {
    $(window).on('resize orientationchange', () => {
      this.loadImagesResponsive()
    })
  }

  loadImagesResponsive() {
    if ($(window).width() >= 768 && !this.dom.$responsiveImage.hasClass('is-loaded-image')) {
      const imageUrl = this.dom.$responsiveImage.data('src')
      this.dom.$responsiveImage.attr('src', imageUrl).removeAttr('data-src').addClass('is-loaded-image')
    }
  }
}

const $modHeroBanner = $('.mod-hero-banner')
if ($modHeroBanner.length) {
  $modHeroBanner.each((_, element) => {
    new ModHeroBanner(element).init()
  })
}
